import StateItemHelper from "./StateItemHelper";
import PromotionHelper from "../Promotion/PromotionHelper";

class MenuEditItemStateHelper {

    static getStateModifierGroup = (modifierGroups: any, modifierGroupId: any) => {
        if (!modifierGroups) return undefined;
        return modifierGroups.filter((modifierGroup: any) => modifierGroup.modifier_group_id === modifierGroupId)[0];
    }
    static getStateModifierGroupSelectedItem = (modifierGroup: any, item_id: any) => {
        if (!modifierGroup) {
            return undefined;
        }
        return modifierGroup.selected_items.filter((selectedItem: any) => selectedItem.item_id === item_id)[0];
    }
    static getStateModifierGroupSelectedItems = (modifierGroup: any, item_id: any) => {
        if (!modifierGroup) {
            return [];
        }
        return modifierGroup.selected_items.filter((selectedItem: any) => selectedItem.item_id === item_id);
    }
    static parseOrderItemToStateItem = (orderItem: any, promotions: any[], cart: any, items: Record<string, any>[]) => {
        let stateItem = MenuEditItemStateHelper._parseOrderItemToStateItem(orderItem, items, undefined);
        StateItemHelper.refreshItemPrice(stateItem, PromotionHelper.getForItem(promotions, stateItem.item_id), cart);
        return stateItem;
    }

    static _parseOrderItemToStateItem = (orderItem: any, items: Record<string, any>[], parentModifierGroupId?: any) => {
        let modifierGroups = [] as any[];
        if (orderItem.modifier_groups) {
            orderItem.modifier_groups.forEach((orderItemModifierGroup: any) => {
                let stateModifierGroup = {
                    modifier_group_id: orderItemModifierGroup.modifier_group_id,
                    selected_items: [] as any[]
                }
                let stateSelectedItems = [] as any[];
                [...orderItemModifierGroup.selected_items].sort((a: Record<string, any>, b: Record<string, any>) => b.total_money.amount - a.total_money.amount).forEach((selectedItem: any) => {
                    const item = items.find(x => x.id === selectedItem.item_id);
                    let stateSelectedItem = this._parseOrderItemToStateItem(selectedItem, items, orderItemModifierGroup.modifier_group_id);
                    let existStateSelectedItem = stateSelectedItems.filter(x => x.item_id === stateSelectedItem.item_id)[0];
                    if (existStateSelectedItem && existStateSelectedItem.modifier_groups.length === 0) {
                        existStateSelectedItem.quantity += stateSelectedItem.quantity;
                    } else {
                        stateSelectedItems.push({
                            ...stateSelectedItem,
                            unit_total_price: item ? item.price.amount : stateSelectedItem.unit_total_price,
                            price: item ? item.price.amount : stateSelectedItem.price,
                        });
                    }
                })
                stateModifierGroup.selected_items = stateSelectedItems;
                modifierGroups.push(stateModifierGroup);
            })
        }
        let stateItem = {
            item_id: orderItem.item_id,
            modifier_groups: modifierGroups,
            name: orderItem.name,
            comment: orderItem.comment,
            price: orderItem.base_unit_price_money?.amount,
            quantity: orderItem.quantity,
            total_price: orderItem.total_money?.amount,
            unit_total_price: orderItem.unit_price_money?.amount
        } as any
        if (parentModifierGroupId) {
            stateItem.parent_modifier_group_id = parentModifierGroupId;
        }
        return stateItem;
    }

    static getModifierGroupSelectedItemState = (itemState: Record<string, any>, modifierGroup: Record<string, any>, modifierGroupOption: Record<string, any>) => {
        const modifierGroupFromProductState = itemState.modifier_groups.find((group: Record<string, any>) => group.modifier_group_id === modifierGroup.id);

        if (!modifierGroupFromProductState) return undefined;

        return modifierGroupFromProductState.selected_items.find((selectedItem: Record<string, any>) => selectedItem.item_id === modifierGroupOption.id);
    }

    static isModifierGroupAdvanced = (modifierGroup: Record<string, any>) => {
        return modifierGroup.options.some((option: Record<string, any>) => option.modifier_groups.length > 0 && option.is_customize);
    }
}

export default MenuEditItemStateHelper;